/**
 * CSS selector to use when you want to style elements that were focused by the mouse and not the keyboard.
 *
 * @see https://css-tricks.com/keyboard-only-focus-styles/
 */
export const mouseFocusSelector = ":focus:not(:focus-visible)";
